import { useEffect, useState } from "react";
import useFetch from "./useFetch";
import usePost from "./usePost";
import useCurrent from "./useCurrent";

const useLicense = (withCreate = true) => {
    const { currentTenantId: tenantId } = useCurrent();
    
    // ✅ التحقق من وجود tenantId قبل الاستدعاء
    const shouldFetch = tenantId && tenantId !== 'undefined';
    const apiUrl = shouldFetch 
        ? `${process.env.REACT_APP_Auth_API_BASE_URL}/licenses/tenant/${tenantId}`
        : null;
    
    const { data, loading } = useFetch(apiUrl);
    const { data: resultPost, postData } = usePost();
    const [isCreated, setIsCreated] = useState(false);

    const TRAIL_PERIOD_DAYS = Number(process.env.REACT_APP_TRAIL_PERIOD_DAYS) || 14;
    const [licenseDays, setLicenseDays] = useState(TRAIL_PERIOD_DAYS);
    const [typeLicense, setTypeLicense] = useState('Trail');

    const createLicense = () => {
        // ✅ التحقق من وجود tenantId
        if (!tenantId || tenantId === 'undefined') {
            console.error('Cannot create license: tenantId is missing');
            return;
        }

        const startDate = new Date();
        const endDate = new Date();
        endDate.setDate(endDate.getDate() + TRAIL_PERIOD_DAYS);

        const _data = {
            tenantId: tenantId,
            companiesCount: 1,
            branchesCount: 1,
            usersCount: 1,
            appIds: ['SALES'],
            typeLicense: 'Trail',
            startDate: startDate,
            endDate: endDate,
        };

        postData(`${process.env.REACT_APP_Auth_API_BASE_URL}/licenses`, _data);
        setIsCreated(true);
    };

    useEffect(() => {
        if (resultPost) {
        }
    }, [resultPost]);

    useEffect(() => {
        // ✅ التحقق من وجود البيانات بشكل آمن
        if (!data || !data.data) {
            return;
        }

        // ✅ التحقق من أن data.data هو array
        if (!Array.isArray(data.data)) {
            console.error('Invalid license data format:', data);
            return;
        }

        // إذا لم توجد رخص، قم بإنشاء واحدة
        if (data.data.length === 0) {
            if (!isCreated && withCreate) {
                createLicense();
            }
            return;
        }

        // ✅ التحقق من وجود الرخصة الأولى
        const firstLicense = data.data[0];
        if (!firstLicense) {
            console.error('First license is undefined');
            return;
        }

        // تحديث نوع الرخصة
        setTypeLicense(firstLicense.typeLicense || 'Trail');

        // ✅ التحقق من وجود endDate قبل استخدامه
        if (firstLicense.endDate) {
            try {
                const endDate = new Date(firstLicense.endDate);
                const currentDate = new Date();
                
                // التحقق من صحة التاريخ
                if (isNaN(endDate.getTime())) {
                    console.error('Invalid endDate:', firstLicense.endDate);
                    return;
                }

                // حساب الفرق بالأيام
                const daysDiff = Math.abs(endDate - currentDate);
                const daysRemaining = Math.ceil(daysDiff / 86400000); // تحويل من milliseconds إلى أيام
                
                setLicenseDays(daysRemaining);
            } catch (error) {
                console.error('Error calculating license days:', error);
            }
        } else {
            console.warn('License endDate is missing');
        }
    }, [data, isCreated, withCreate, tenantId]);

    return { 
        data, 
        loading, 
        licenseDays, 
        typeLicense,
        isCreated 
    };
};

export default useLicense;